// extracted by mini-css-extract-plugin
export var saHomeBoxesSection = "saBoxes4-module--saHomeBoxesSection--1IhnV";
export var saBoxesTitleContainer = "saBoxes4-module--saBoxesTitleContainer--20w3q";
export var saBoxesTextContainer = "saBoxes4-module--saBoxesTextContainer--1EAHY";